import classNames from 'classnames';
import DOMPurify from 'dompurify';
import React from 'react';
import { Tooltip } from 'tdesign-react';

import { Question, RequiredIcon } from '@/components/icon';
import { TIP_TITLE } from '@/const/tip';
import { useTypedSelector } from '@/store';

import styles from './index.module.less';

interface IProps {
  title?: string | ((values: Record<string, unknown>) => string);
  secTitle?: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  replaceObject: { [key: string]: unknown };
  border?: boolean;
  required?: boolean;
  cssStyle?: React.CSSProperties;
  pageId?: string;
  labelSetting?: { tipIcon?: boolean, tipText?: string, }
}

export const FormTitle: React.FC<IProps> = (props) => {
  const tipList = useTypedSelector(store => store.tip);
  const { title, subTitle, replaceObject, border, secTitle, required, cssStyle, labelSetting, pageId } = props;

  const titleStr = typeof title === 'string' ? title : title?.(replaceObject) || '';

  const createMarkup = (html: string) => ({ __html: DOMPurify.sanitize(html) });

  let { tipIcon } = labelSetting || {};
  const { tipText } = labelSetting || {};
  let singleText = tipIcon ? null : tipText;
  let richText = tipIcon ? tipText : null;
  let custom: string | null = null;

  if (pageId) {
    if (Array.isArray(tipList) && tipList.length > 0) {
      const matchedTip = tipList.find((tip: any) => tip
        && tip.pageId === pageId
        && tip.moduleId === TIP_TITLE
        && (tip.title === titleStr || tip.title === secTitle?.toString()));
      if (matchedTip) {
        ({ hasIcon: tipIcon, singleText, richText, custom } = matchedTip);
      }
    }
  }

  if (!title && !secTitle && !subTitle) {
    return null;
  }

  const showTooltip = !!tipIcon && (!!custom || (!!richText && richText !== '<p></p>'));

  const getTooltipContent = () => {
    if (custom) {
      return <div dangerouslySetInnerHTML={createMarkup(custom)} />;
    }
    if (richText && richText !== '<p></p>') {
      return <div dangerouslySetInnerHTML={createMarkup(richText)} />;
    }
    return null;
  };

  return (
    <div
      className={classNames(styles.titleWrapper, { [styles.border]: border })}
      style={{ ...cssStyle }}
    >
      {title && <span className={classNames(styles.title)}>{titleStr}</span>}

      {required && <span className={styles.required}><RequiredIcon /></span>}

      {secTitle && <span className={styles.secTitle}>{secTitle}</span>}

      {subTitle && <span className={styles.subTitle}>{subTitle}</span>}

      {singleText && <span className={styles.singleText}>{singleText}</span>}

      {showTooltip && <Tooltip
        content={getTooltipContent()}
        destroyOnClose
        showArrow
        theme="default"
        overlayClassName={custom ? styles.customTooltip : undefined}
      >
        <div className={styles.toolTipText}>
          <Question />
        </div>
      </Tooltip>}
    </div>
  );
};
